import { useContext } from 'react';
import { PlaycastContext } from '../../PlayerContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGearComplex } from '@fortawesome/pro-solid-svg-icons';
import { store } from '../store';

export const OptionsToggle = () => {
  const data = useContext(PlaycastContext);

  const toggleOptions = () => {
    store.updatePlayerOptionsOpen(!data.options.open);
  };

  // Only show in spectator mode
  if (data.mode.mode === 'player') return null;

  return (
    <div className='z-100 absolute right-4 top-4 flex cursor-pointer space-x-4'>
      <FontAwesomeIcon icon={faGearComplex} className='text-amber-400 opacity-50' size='lg' onClick={toggleOptions} />
    </div>
  );
};
